import {EVENT_SHOPPING_CART, LOCALE_STORAGE_SHOPPING_CART} from '../constants';

/**
 * Adds a product to cart.
 * @param {string} productUri
 * @param {string} productName
 * @param {string} productClass
 * @param {string} productNumber
 * @param {string} packageSize
 * @param {string} quantity
 */
export default function addToCart(productUri, productName, productClass, productNumber, packageSize, quantity) {
    let savedItems = JSON.parse(localStorage.getItem(LOCALE_STORAGE_SHOPPING_CART))

    if (savedItems) {
        let isAlreadyInCart = false
        savedItems.forEach((product) => {
            if (product.productClass === productClass && product.packageSize === packageSize && product.productNumber === productNumber && product.productName === productName) {
                // convert to number, to add quantity instead of append
                product.quantity = +product.quantity + +quantity
                isAlreadyInCart = true
            }
        })

        if (!isAlreadyInCart) savedItems.push({productUri, productName, productClass, productNumber, packageSize, quantity})
    } else {
        savedItems = [{productUri, productName, productClass, productNumber, packageSize, quantity}]
    }

    localStorage.setItem(LOCALE_STORAGE_SHOPPING_CART, JSON.stringify(savedItems))
    window.dispatchEvent(new Event(EVENT_SHOPPING_CART))
}
